import ThumbnailSelectable from './ThumbnailSelectable'

export default ThumbnailSelectable



// WEBPACK FOOTER //
// ./src/components/ThumbnailSelectable/index.js